import i18n from '@/i18n'

const roleGroups = [
  {
    name: i18n.t('roles.customerService'),
    roles: ['Portal.CustomerService', 'Mapi.CustomerService'],
    description: i18n.t('roles.customerServiceExplanation'),
    canUsedFor: ['internal']
  }, {
    name: i18n.t('roles.finance'),
    roles: ['Portal.Finance', 'Mapi.ExternalFinance'],
    description: i18n.t('roles.financeExplanation'),
    canUsedFor: ['business', 'merchant']
  }, {
    name: i18n.t('roles.externalDeveloper'),
    roles: ['Portal.ExternalDeveloper', 'Mapi.ExternalDeveloper'],
    description: i18n.t('roles.externalDeveloperExplanation'),
    canUsedFor: ['business', 'merchant']
  }, {
    name: i18n.t('roles.financeAdmin'),
    roles: ['Portal.FinanceAdmin'],
    description: i18n.t('roles.financeAdminExplanation'),
    canUsedFor: ['internal']
  }, {
    name: i18n.t('roles.owner'),
    roles: ['Portal.Owner', 'Mapi.ExternalAdmin'],
    description: i18n.t('roles.ownerExplanation'),
    canUsedFor: ['business']
  }, {
    name: i18n.t('roles.sales'),
    roles: ['Portal.Sales', 'Mapi.ExternalTransactional'],
    description: i18n.t('roles.salesExplanation'),
    canUsedFor: ['business', 'merchant']
  }, {
    name: i18n.t('roles.technicalAdmin'),
    roles: ['Portal.TechAdmin', 'Mapi.TechAdmin'],
    description: i18n.t('roles.technicalAdminExplanation'),
    canUsedFor: ['internal']
  }, {
    name: i18n.t('roles.implementations'),
    roles: ['Portal.Implementations', 'Mapi.Implementations'],
    description: i18n.t('roles.implementationsExplanation'),
    canUsedFor: ['internal']
  }, {
    name: i18n.t('roles.virtualTerminal'),
    roles: ['Portal.VirtualTerminal', 'Mapi.VirtualTerminal'],
    description: i18n.t('roles.virtualTerminalExplanation'),
    canUsedFor: ['business', 'merchant']
  }, {
    name: i18n.t('roles.internalReadOnly'),
    roles: ['Portal.InternalReadOnly', 'Mapi.InternalReadOnly'],
    description: i18n.t('roles.internalReadOnlyExplanation'),
    canUsedFor: ['internal']
  }, {
    name: i18n.t('roles.riskAnalyst'),
    roles: ['Portal.RiskAnalyst', 'Mapi.RiskAnalyst'],
    description: i18n.t('roles.riskAnalystExplanation'),
    canUsedFor: ['internal']
  }, {
    name: i18n.t('roles.operationalSupervisor'),
    roles: ['Portal.OperationalSupervisor'],
    description: i18n.t('roles.operationalSupervisorExplanation'),
    canUsedFor: ['internal'] // Check if ok??
  }
]

export default {
  methods: {
    getRoleGroupsFromRoles (roles = [], usage) {
      return roleGroups.filter(group => group.roles.every(role => roles.includes(role)) && group.canUsedFor.includes(usage)).sort((a, b) => a.name.localeCompare(b.name))
    },

    getRolesFromRoleGroups (groups = []) {
      return [...new Set(roleGroups.filter(group => groups.includes(group.name)).map(group => group.roles).reduce((a, b) => a.concat(b), []))]
    }
  }
}
